<script setup lang="ts">
import SearchField from '@/components/filter/SearchField.vue';
import { TaskSelectionFilterObject } from '../types';

const modelValue = defineModel<TaskSelectionFilterObject>({ required: true });
</script>

<template>
  <v-row>
    <v-col cols="10">
      <SearchField v-model="modelValue.search" :label="false" :placeholder="$t('Search')" />
    </v-col>
  </v-row>
</template>
